// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4965":"683aaa32","9628":"ffe73276"}[chunkId] + ".chunk.css";
};